const availableTranslations = {
  sole: "Sohle",
  stripes: "Streifen",
  mesh: "Gitter",
  band: "Schlaufe",
  patch: "Pflaster",
  laces: "Schnürsenkel",
  inner: "Innensohle",
};

export const getPartName = (name) => (availableTranslations[name] !== undefined ? availableTranslations[name] : name);
